module.exports = __webpack_public_path__ + "img/presscoins-logo.f05c5e94.svg";